module App.Interfaces {
    export interface IDefaultFormScope extends ng.IScope {
        form: ng.IFormController;
        isSubmitting: boolean;
    }
}